import * as env from './env'

const currencies = [
    {
        name: 'Dollar',
        code: 'USD',
        symbol: '$',
        isAfter: 0,
        chips: [1, 5, 25, 100, 500, 1000],
    },
    {
        name: 'Euro',
        code: 'EUR',
        symbol: '€',
        isAfter: 0,
        chips: [5, 25, 50, 100, 250, 1000],
    },
    {
        name: 'Pound sterling',
        code: 'GBP',
        symbol: '£',
        isAfter: 0,
        chips: [5, 25, 50, 100, 250, 1000],
    },
    {
        name: 'Ruble',
        code: 'RUB',
        symbol: '₽',
        isAfter: 1,
        chips: [50, 250, 500, 1000, 2500, 10000],
    },
    {
        name: 'Japanese yen',
        code: 'JPY',
        symbol: '¥',
        isAfter: 1,
        chips: [50, 250, 500, 1000, 2500, 10000],
    },
    {
        name: 'Swiss frank',
        code: 'CAD',
        symbol: '₣',
        isAfter: 1,
        chips: [5, 25, 50, 100, 250, 1000],
    },
    {
        name: 'South Korean Won',
        code: 'KRW',
        symbol: '₩',
        isAfter: 1,
        chips: [5000, 25000, 50000, 100000, 250000, 1000000],
    },
    {
        name: 'Kazakh tenge',
        code: 'KZT',
        symbol: '₸',
        isAfter: 1,
        chips: [200, 1000, 5000, 25000, 50000, 100000],
    },
    {
        name: 'Ukrainian hryvnia',
        code: 'UAH',
        symbol: '₴',
        isAfter: 1,
        chips: [500, 1000, 2000, 5000, 10000, 20000]
    },
    {
        name: 'Uzbek sum',
        code: 'UZS',
        symbol: 'сўм',
        isAfter: 1,
        chips: [100000, 200000, 500000, 1000000, 5000000, 10000000]
    },
    {
        name: 'Kyrgyz som',
        code: 'KGS',
        symbol: 'с.',
        isAfter: 1,
        chips: [50, 250, 500, 1000, 2500, 10000],
    },
]

/* Array total */
const arrayTotal = array => {
    let total = 0
    array.forEach(item => {
        if (item && item.sum) {
            total += item.sum
        }
    })
    return total
}

/* Balance convertor */
const convertor = (number, currency, symbol = " ") => {

    let space = '\xa0'
    /* Check the price for the void */
    if (number === null || number === undefined)
        return ""

    const balance = parseFloat(number)

    let final = Number.isInteger(balance) ? balance.toFixed(0) : balance.toFixed(2)

    if (currency.toLowerCase() === 'uzs') {
        final = counter(final)
    }

    const index = currencies.findIndex(c => c.code.toLowerCase() === currency.toLowerCase())

    let beforeSymbol = ''
    let afterSymbol = ''

    if (index > -1) {
        if (currencies[index].isAfter === 1) {
            afterSymbol = space + currencies[index].symbol
        }
        if (currencies[index].isAfter === 0) {
            beforeSymbol = currencies[index].symbol + space
        }
    }
    else {
        beforeSymbol = "$" + space
    }

    /* Return price with spaces and currency */
    return beforeSymbol + final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, symbol) + afterSymbol
}


/* Check for empty */
const isEmpty = data => {
    if (data === null || data === undefined) {
        return false
    }

    return true
}


/* Counter */
const counter = (value, fixed = 1) => {

    let count = value

    if (parseInt(value) >= 1000) {
        if (parseInt(value) % 1000 === 0) {
            const calculate = Math.round(parseInt(value) / 1000)
            count = `${calculate}K`
        }
        else if (parseInt(value) % 100 === 0) {
            const calculate = (parseInt(value) / 1000).toFixed(fixed)
            count = `${calculate}K`
        }
    }

    if (parseInt(value) >= 1000000) {
        const calculate = (parseInt(value) / 1000000).toFixed(fixed)
        count = `${calculate}M`
    }

    return count
}

/* Divide number */
const numberWithSpaces = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

const fontSize = (value, defaultValue = 15) => {
    const ante_length = (String(counter(value))).length

    const size = defaultValue - (ante_length > 3 ? ante_length : 0) + 1

    return size
}

const get_unique_values = (arr, prop) => {
    return arr.filter((obj, index, self) =>
        index === self.findIndex((o) =>
            o[prop] === obj[prop]
        )
    )
}

/* Get Chips Function */
const getChips = chips => {

    /* Fields */
    let data = []

    /* Check Chips */
    if (chips && Array.isArray(chips) && chips.length > 0) {
        chips.forEach((chip, index) => {
            data.push({ key: index + 1, value: parseInt(chip) })
        })
    }

    return data
}

const isMobile = (() => {
    if (typeof navigator === 'undefined') return false

    const ua = navigator.userAgent || navigator.vendor || window.opera

    // iPadOS (маскируется под Mac)
    const isIPadOS = ua.includes('Mac') && navigator.maxTouchPoints > 1

    // Классические мобильные
    const isMobileUA = /Android|webOS|iPhone|iPod|BlackBerry|Windows Phone/i.test(ua)

    return isMobileUA || isIPadOS
})()

const convertRemToPixels = (rem) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
}

// Красные числа европейской рулетки
const RED_NUMBERS = new Set([
    1, 3, 5, 7, 9, 12, 14, 16,
    18, 19, 21, 23, 25, 27, 30,
    32, 34, 36
]);

// 🟢 Проверка нуля
const isZero = (n) => {
    return Number(n) === 0;
}

// 🔴 Проверка красного цвета
const isRed = (n) => {
    n = Number(n);
    return RED_NUMBERS.has(n);
}

const chipFormat = (num) => {

    //
    // BILLIONS (B)
    //
    if (num >= 1_000_000_000) {
        let raw = num / 1_000_000_000;
        let base = Math.floor(raw * 10) / 10;
        base = String(base).replace(/\.0+$/, "").replace(/(\.\d)0$/, "$1");
        return base + "B";
    }

    //
    // MILLIONS (M)
    //
    if (num >= 1_000_000) {
        let raw = num / 1_000_000;
        let base = Math.floor(raw * 10) / 10;
        base = String(base).replace(/\.0+$/, "").replace(/(\.\d)0$/, "$1");
        return base + "M";
    }

    //
    // 100 000 – 999 999 → 1 знак
    //
    if (num >= 100_000) {
        let raw = num / 1000;
        let base = Math.floor(raw * 10) / 10;
        base = String(base).replace(/\.0$/, "");
        return base + "K";
    }

    //
    // 10 000 – 99 999 → 2 знака
    //
    if (num >= 10_000) {
        let raw = num / 1000;
        let base = Math.floor(raw * 10) / 10;
        base = String(base).replace(/\.0+$/, "").replace(/(\.\d)0$/, "$1");
        return base + "K";
    }

    //
    // 1000 – 9999 → НОВОЕ ПРАВИЛО
    //
    if (num >= 1000) {
        const raw = num / 1000;

        // оставляем как есть, если дробная часть длиннее одного знака
        if (Math.floor(raw * 10) !== raw * 10) {
            return String(num);
        }

        // иначе показываем X.XK или XK
        let base = raw;
        base = String(base).replace(/\.0$/, "");
        return base + "K";
    }

    //
    // < 1000
    //
    return String(num);
};


/*
 * Z-INDEX ФИШЕК
 *
 * Фишка с большей суммой должна лежать поверх фишки с меньшей суммой.
 * Раскладываем ставки по возрастанию и берём позицию суммы в этом списке —
 * так порядок наложения зависит только от суммы, а не от позиции на столе.
 * Диапазон ограничен CHIP_Z_LIMIT, чтобы фишки не перекрывали интерфейс
 * (кнопки стола, dolly) — те лежат выше CHIP_Z_BASE + CHIP_Z_LIMIT.
 */
const CHIP_Z_BASE = 20
const CHIP_Z_LIMIT = 200

const chipZIndex = (value, stakes) => {

    const amount = Number(value) || 0

    let rank = 0

    if (stakes && Array.isArray(stakes)) {
        const seen = []
        stakes.forEach(s => {
            const v = Number(s.value) || 0
            if (v < amount && !seen.includes(v)) seen.push(v)
        })
        rank = seen.length
    }

    return CHIP_Z_BASE + Math.min(rank, CHIP_Z_LIMIT)
}


export { isEmpty, arrayTotal, convertor, counter, numberWithSpaces, fontSize, getChips, get_unique_values, isMobile, convertRemToPixels, isZero, isRed, chipFormat, chipZIndex }